const NETWORK_SCHEME = /^[a-z][a-z0-9+\-.]*:\/\//i
const OPAQUE_SCHEME = /^(mailto|tel|sms|data|file|news):/i

function hasScheme(s: string): boolean {
  return NETWORK_SCHEME.test(s) || OPAQUE_SCHEME.test(s)
}

export function normalizeWebsite(input: string): string {
  const trimmed = input.trim()
  if (trimmed === '') return trimmed
  if (/^https:\/\//i.test(trimmed)) {
    return trimmed.replace(/^https:\/\//i, 'https://')
  }
  if (/^http:\/\//i.test(trimmed)) {
    return trimmed.replace(/^http:\/\//i, 'https://')
  }
  if (hasScheme(trimmed)) return trimmed
  return `https://${trimmed.replace(/^\/+/, '')}`
}

export function isValidWebsite(input: string): boolean {
  const trimmed = input.trim()
  if (trimmed === '') return true
  let url: URL
  try {
    url = new URL(normalizeWebsite(trimmed))
  } catch {
    return false
  }
  if (url.protocol !== 'https:') return false
  if (!/\.[a-z]{2,}$/i.test(url.hostname)) return false
  return true
}

/** the visible form of a website: host + path, no scheme, no www, no trailing
 * slash. falls back to the raw input when it does not parse.
 */
export function websiteLabel(input: string): string {
  const trimmed = input.trim()
  if (trimmed === '') return trimmed
  let url: URL
  try {
    url = new URL(normalizeWebsite(trimmed))
  } catch {
    return trimmed
  }
  const host = url.hostname.replace(/^www\./i, '')
  const path = `${url.pathname}${url.search}`.replace(/\/$/, '')
  return `${host}${path}`
}

export function safeNext(raw: string | null | undefined): string {
  if (!raw) return '/'
  let decoded: string
  try {
    decoded = decodeURIComponent(raw)
  } catch {
    return '/'
  }

  if (!decoded.startsWith('/')) return '/'
  // parse it the way the browser will: tabs, newlines and backslashes can turn "/…" into another origin
  const url = new URL(decoded, window.location.origin)
  if (url.origin !== window.location.origin) return '/'
  return `${url.pathname}${url.search}${url.hash}`
}
